module.exports = __webpack_public_path__ + "img/mind_template_item_1_5.c25525cf.png";